// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const apiKeyInNameMax = 60;

export const apiKeyInScopesOneItemMax = 64;

export const apiKeyInScopesOneMax = 20;

export const ApiKeyIn = zod.object({
  "expires_on": zod.iso.date(),
  "name": zod.string().min(1).max(apiKeyInNameMax),
  "scopes": zod.union([zod.array(zod.string().max(apiKeyInScopesOneItemMax)).min(1).max(apiKeyInScopesOneMax),zod.null()]).optional()
});

export type ApiKeyIn = zod.input<typeof ApiKeyIn>;
export type ApiKeyInOutput = zod.output<typeof ApiKeyIn>;
